import { UsefulLink } from '../../shared/interfaces/useful-link';

export const links: UsefulLink[] = [
  {
    link: '#',
    text: 'סילבוס'
  },
  {
    link: '#',
    text: 'סריקת מחברות בחינה'
  },
  {
    link: '#',
    text: 'לוח שנה אקדמי'
  },
  {
    link: '#',
    text: 'שחזור ספח בחינה'
  },
  {
    link: '#',
    text: 'מערכת ערעורים'
  },
  {
    link: '#',
    text: 'מאגרי בחינות וסיכומים'
  },
  {
    link: '#',
    text: 'המדריך לבחינות מקוונות'
  },
  {
    link: '#',
    text: 'מדור בחינות, מערכת שעות ומס"ר'
  }
];
